import React, { memo } from "react";

import { makeStyles } from "@material-ui/styles";
import SvgIcon from "@material-ui/core/SvgIcon";

const useStyles = makeStyles({
  icon: {
    width: "1.5rem",
    height: "1.5rem",
    fill: "#FFD500",
  },
});

const WarningIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 25 25" className={styles.icon}>
      <path d="M23.8754 19.1123L14.3908 2.44653C13.9572 1.66066 13.1443 1.19998 12.1958 1.19998C11.2473 1.19998 10.4615 1.66066 10.0008 2.44653L0.516225 19.1123C0.082645 19.8981 0.082645 20.8466 0.516225 21.6325C0.949806 22.4183 1.76277 22.879 2.68413 22.879H21.6262C22.5475 22.879 23.3605 22.4183 23.7941 21.6325C24.3089 20.8466 24.3089 19.8981 23.8754 19.1123ZM13.5778 18.9226H11.0576V16.7276H13.5778V18.9226ZM13.5778 15.4539H11.0576V9.16702H13.5778V15.4539Z" />
    </SvgIcon>
  );
};

export default memo(WarningIcon);
